const adsSupportedCountries = ['US',
// United States
'CA',
// Canada
'MX',
// Mexico
'AT',
// Austria
'GB',
// United Kingdom
'FR',
// France
'DE',
// Germany
'IT',
// Italy
'ES',
// Spain
'NL',
// Netherlands
'SE',
// Sweden
'PL',
// Poland
'CZ',
// Czech Republic
'TR',
// Turkey
'BE',
// Belgium
'EG',
// Egypt
'AE',
// United Arab Emirates
'SA',
// Saudi Arabia
'IL',
// Israel
'SG',
// Singapore
'AU',
// Australia
'JP',
// Japan
'IN',
// India
'CN',
// China
'KR',
// South Korea
'TH',
// Thailand
'VN',
// Vietnam
'TW',
// Taiwan
'BR',
// Brazil
'CO' // Colombia
];

/* eslint-disable id-length */
const allCountries = [...adsSupportedCountries, 'LU',
// Luxembourg
'CH',
// Switzerland
'NO',
// Norway
'NZ',
// New Zealand
'DK',
// Denmark
'IE',
// Ireland
'FI',
// Finland
'MA',
// Morocco
'BH',
// Bahrain
'QA',
// Qatar
'KW',
// Kuwait
'ID',
// Indonesia
'PT',
// Portugal
'RO',
// Romania
'GR',
// Greece
'HU',
// Hungary
'ZA',
// South Africa
'SK',
// Slovakia
'HR',
// Croatia
'BG',
// Bulgaria
'PK',
// Pakistan
'LT',
// lithuania
'EE',
// Estonia
'LV',
// Latvia
'DZ',
// Algeria
'TN',
// Tunisia
'CY',
// Cyprus
'PH',
// Philippines
'MY',
// Malaysia
'HK',
// Hong Kong
'CL',
// Chile
'AR',
// Argentina
'PE',
// Peru
'EC',
// Ecuador
'CR',
// Costa Rica
'GT',
// Guatemala
'PA',
// Panama
'UY',
// Uruguay
'DO',
// Dominican Republic
'PR',
// Puerto Rico
'SV',
// El Salvador
'PY',
// Paraguay
'HN',
// Honduras
'JM' // Jamaica
];

// Alternative search terms for countries
const countrySearchAliases = {
  AE: ['United Arab Emirates', 'UAE', 'U.A.E.', 'الإمارات', 'Emirates'],
  AR: ['Argentina', 'Argentine Republic', 'República Argentina'],
  AT: ['Austria', 'Republic of Austria', 'Österreich'],
  AU: ['Australia', 'Commonwealth of Australia', 'Aussie'],
  BE: ['Belgium', 'Kingdom of Belgium', 'België', 'Belgique', 'Belgien'],
  BG: ['Bulgaria', 'Republic of Bulgaria', 'България'],
  BH: ['Bahrain', 'Kingdom of Bahrain', 'Al-Bahrayn'],
  BR: ['Brazil', 'Brasil', 'Federative Republic of Brazil', 'República Federativa do Brasil'],
  CA: ['Canada', 'Canadian'],
  CH: ['Switzerland', 'Swiss Confederation', 'Schweiz', 'Suisse', 'Svizzera', 'Svizra'],
  CL: ['Chile', 'Republic of Chile', 'República de Chile'],
  CN: ['China', 'People\'s Republic of China', 'Peoples Republic of China', 'PRC', '中华人民共和国', '中国'],
  CO: ['Colombia', 'Republic of Colombia', 'República de Colombia'],
  CR: ['Costa Rica', 'Republic of Costa Rica', 'República de Costa Rica'],
  CZ: ['Czech Republic', 'Czechia', 'Česko'],
  CY: ['Cyprus', 'Republic of Cyprus', 'Κύπρος', 'Kýpros'],
  DE: ['Germany', 'Federal Republic of Germany', 'Deutschland'],
  DK: ['Denmark', 'Kingdom of Denmark', 'Danmark'],
  DO: ['Dominican Republic', 'República Dominicana'],
  DZ: ['Algeria', 'People\'s Democratic Republic of Algeria', 'Peoples Democratic Republic of Algeria', 'Algérie', 'Al-Jazair'],
  EC: ['Ecuador', 'Republic of Ecuador', 'República del Ecuador'],
  EE: ['Estonia', 'Republic of Estonia', 'Eesti'],
  EG: ['Egypt', 'Arab Republic of Egypt', 'مصر'],
  ES: ['Spain', 'Kingdom of Spain', 'España'],
  FI: ['Finland', 'Republic of Finland', 'Suomi'],
  FR: ['France', 'French Republic', 'République française'],
  GB: ['United Kingdom', 'UK', 'U.K.', 'Britain', 'Great Britain', 'England', 'Scotland', 'Wales', 'Northern Ireland'],
  GR: ['Greece', 'Hellenic Republic', 'Hellas', 'Ελλάδα'],
  GT: ['Guatemala', 'Republic of Guatemala', 'República de Guatemala'],
  HK: ['Hong Kong', 'Hong Kong SAR', 'Hong Kong Special Administrative Region', '香港'],
  HN: ['Honduras', 'Republic of Honduras', 'República de Honduras'],
  HR: ['Croatia', 'Republic of Croatia', 'Hrvatska'],
  HU: ['Hungary', 'Magyarország'],
  ID: ['Indonesia', 'Republic of Indonesia', 'Republik Indonesia'],
  IE: ['Ireland', 'Republic of Ireland', 'Éire'],
  IL: ['Israel', 'State of Israel', 'יִשְׂרָאֵל', 'ישראל'],
  IN: ['India', 'Republic of India', 'Bharat', 'भारत'],
  IT: ['Italy', 'Italian Republic', 'Repubblica Italiana', 'Italia'],
  JM: ['Jamaica', 'Jamaican'],
  JP: ['Japan', '日本', 'Nihon', 'Nippon'],
  KR: ['South Korea', 'Republic of Korea', 'Korea', '한국', '대한민국'],
  KW: ['Kuwait', 'State of Kuwait', 'Al-Kuwayt'],
  LT: ['Lithuania', 'Republic of Lithuania', 'Lietuva'],
  LU: ['Luxembourg', 'Grand Duchy of Luxembourg', 'Lëtzebuerg'],
  LV: ['Latvia', 'Republic of Latvia', 'Latvija'],
  MA: ['Morocco', 'Kingdom of Morocco', 'Al-Maghrib', 'Maghreb'],
  MX: ['Mexico', 'México', 'Estados Unidos Mexicanos'],
  MY: ['Malaysia', 'Federation of Malaysia', 'Malaysia Negara'],
  NL: ['Netherlands', 'The Netherlands', 'Holland', 'Nederland'],
  NO: ['Norway', 'Kingdom of Norway', 'Norge', 'Noreg'],
  NZ: ['New Zealand', 'Aotearoa'],
  PA: ['Panama', 'Republic of Panama', 'República de Panamá'],
  PE: ['Peru', 'Republic of Peru', 'República del Perú'],
  PH: ['Philippines', 'Republic of the Philippines', 'Pilipinas'],
  PK: ['Pakistan', 'Islamic Republic of Pakistan', 'پاکستان'],
  PL: ['Poland', 'Republic of Poland', 'Rzeczpospolita Polska'],
  PR: ['Puerto Rico', 'Commonwealth of Puerto Rico'],
  PT: ['Portugal', 'Portuguese Republic', 'República Portuguesa'],
  PY: ['Paraguay', 'Republic of Paraguay', 'República del Paraguay'],
  QA: ['Qatar', 'State of Qatar', 'Qaṭar'],
  RO: ['Romania', 'România'],
  SA: ['Saudi Arabia', 'Kingdom of Saudi Arabia', 'KSA', 'السعودية'],
  SE: ['Sweden', 'Kingdom of Sweden', 'Sverige'],
  SG: ['Singapore', 'Republic of Singapore', 'Singapura', '新加坡'],
  SK: ['Slovakia', 'Slovak Republic', 'Slovenská republika'],
  SV: ['El Salvador', 'Republic of El Salvador', 'República de El Salvador'],
  TH: ['Thailand', 'Kingdom of Thailand', 'ประเทศไทย'],
  TN: ['Tunisia', 'Republic of Tunisia', 'Tunisie', 'Tunis'],
  TR: ['Turkey', 'Republic of Türkiye', 'Türkiye'],
  TW: ['Taiwan', 'Republic of China', 'ROC', '臺灣', '台湾'],
  US: ['United States', 'USA', 'U.S.', 'U.S.A.', 'America', 'United States of America'],
  UY: ['Uruguay', 'Oriental Republic of Uruguay', 'República Oriental del Uruguay'],
  VN: ['Vietnam', 'Viet Nam', 'Socialist Republic of Vietnam', 'Việt Nam'],
  ZA: ['South Africa', 'Republic of South Africa', 'RSA']
};

export { allCountries as a, adsSupportedCountries as b, countrySearchAliases as c };
//# sourceMappingURL=countryLists-Ck89Ck3L.js.map
